import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import methodModel from '../../../methods/methods';

const ContentViewPage = (p) => {
  const history = useNavigate();
  const { id, userId } = useParams();
  const [data, setData] = useState();

  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`content`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">View Content</h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your Content
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Title</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.title)}
            </div>
          </div>


          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Description</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">

              <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>
            </div>
          </div>

          {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div>
                <div className="imagethumbWrapper">
                  <img
                    src={methodModel.noImg(data && data?.image, 'users')}
                    className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                  />
                </div>
              </div>
            </div>
          ) : null}
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Meta Title</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.meta_title)}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Meta Keyword</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.meta_key)}
            </div>
          </div>


          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Meta Description</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">

              <div dangerouslySetInnerHTML={{ __html: data?.meta_description }}></div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContentViewPage;
